/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import Skeleton from 'react-loading-skeleton';
import { PRODUCT_NAME } from '@constants';
import dayjs from 'dayjs';
import {
  useEffect, useCallback, useState,
} from 'react';
import request from '@api';
import classes from './content.module.css';
import { getDashboardData } from './const';
// import { mockQueryMetrics } from './Mock';

const Card = ({ item }) => {
  const { title, desc, dataValue } = item;
  return (
    <div className={classes.card}>
      <div className={classes.card_data_value}>{dataValue}</div>
      <div className={classes.card_title}>{title}</div>
      <div className={classes.card_desc}>{desc}</div>
    </div>
  );
};
function ProductSkeleton() {
  const productsInvolved = new Array(2).fill(0);
  return (
    <div className={classes.wrapper}>

      {productsInvolved.map((_, pIndex) => {
        const data = new Array(4).fill(0);
        return (
          <div className={classes.row} key={pIndex}>
            <div className={classes.title_wrapper}>
              <Skeleton containerClassName={classes.title} style={{ height: '100%', width: '346PX' }} />
              <Skeleton containerClassName={classes.status} style={{ height: '100%', width: '70PX' }} />
            </div>
            <Skeleton containerClassName={classes.status} style={{ height: '100%', width: '186PX', marginTop: 20 }} />
            <div className={classes.card_wrapper}>
              {data.map((item, index) => (
                <div className={classes.card} key={index}>
                  <div className={classes.card_data_value}>
                    <Skeleton style={{ height: '100%', width: '160PX' }} />
                  </div>
                  <div className={classes.card_title}>
                    <Skeleton style={{ height: '100%', width: '140PX' }} />
                  </div>
                  <div className={classes.card_desc}>
                    <Skeleton containerClassName={classes.card_desc} style={{ height: '100%', maxWidth: '250PX' }} />
                    <Skeleton containerClassName={classes.card_desc} style={{ height: '100%', maxWidth: '250PX' }} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}
// 产品申请进度提示  products page 有用
export const ProductProcessTips = ({ involvedStatus, liveDate }) => (
  ['pending', 'inactive'].includes(involvedStatus)
  && (
    <div className={classes.tips}>
      {involvedStatus === 'pending' ? 'Application is under review'
        : `Go-live date is ${dayjs.utc(liveDate).tz('America/New_York').format('MMM DD, YYYY hh:mm a')} (ET)`}
    </div>
  )
);
// 产品申请状态 products page 有用
export const ProductStatus = ({ status }) => <div className={`${classes.status} ${classes[status]}`}>{status}</div>;

export default ({ productsGallery, galleryLoading }) => {
  const [dataList, setDataList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  // const { store: { name } } = useConnectionContext();
  const fetchData = useCallback(async () => {
    setIsLoading(true);
    try {
      const { code, data = {} } = await request('merchant-metrics');
      // const { code, data } = mockQueryMetrics();
      if (code === 0) {
        const { metrics = [], currencySymbol } = data;
        const list = productsGallery.filter((item) => item.status !== 'coming soon').map((item) => {
          const info = metrics.find((v) => v.insuranceId === item.insuranceName) || {};
          return {
            ...info,
            ...item,
            data: getDashboardData({ ...info, ...item }, currencySymbol),
          };
        });
        setDataList(list.sort((a, b) => b.insuranceId - a.insuranceId));
      }
    } catch (e) {
      console.log(e);
    }
    setIsLoading(false);
  });
  useEffect(() => {
    if (productsGallery) {
      fetchData();
    }
  }, [productsGallery]);

  if (galleryLoading || isLoading) {
    return <ProductSkeleton isLoading={galleryLoading} />;
  }
  return (
    <div className={classes.wrapper}>
      {dataList.map((product) => {
        const {
          insuranceName, involvedStatus, data = [], process, liveDate,
        } = product;
        return (
          <div className={classes.row} key={insuranceName}>
            <div className={classes.title_wrapper}>
              <div className={classes.title}>{insuranceName}</div>
              {!['void', 'unavailable'].includes(involvedStatus) && <ProductStatus status={involvedStatus} />}
            </div>
            {insuranceName === PRODUCT_NAME.RETURN_ASSURANCE && <ProductProcessTips involvedStatus={involvedStatus} liveDate={liveDate} />}

            {process && <div className={classes.process}></div>}
            <div className={classes.card_wrapper}>
              {data.map((item) => (
                <Card
                  item={item}
                  key={item.id}
                />
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};
